import type { Context } from 'hono';
import type { AsyncLocalStorage } from 'async_hooks';

export type RequestContext = {
  honoContext: Context;
  translations: Excite.Core.TranslatedTextsApiModel;
  initialData: Excite.ContentApi.FullPageLoadApiModel;
  fastLoadImages?: Excite.ContentApi.FastLoadImage[];
  additional: { [property: string]: any };
  linkHeaders: string[];
  isMobile: boolean;
  version: string;
  apiVersion: string;
  apiResponseStatus: number;
  apiCacheControl: string;
};

function getAsyncLocalStorage() {
  const asyncLocalStorage: AsyncLocalStorage<{ context: RequestContext }> = global.exciteAsyncLocalStorage;
  return asyncLocalStorage;
}

export function copyResponseHeaders(response: Response, c: Context) {
  response.headers.forEach((value, key) => {
    if (
      key?.toLowerCase() !== 'transfer-encoding' &&
      key?.toLowerCase() !== 'cache-control' &&
      key?.toLowerCase() !== 'cf-cache-status' &&
      key?.toLowerCase() !== 'cf-ray'
    ) {
      c.res.headers.append(key, value);
    }
  });
}

export function createRequestContext(context: RequestContext) {
  if (!__BROWSER__) {
    const asyncLocalStorage = getAsyncLocalStorage();
    asyncLocalStorage.getStore()!.context = context;
    return context;
  } else {
    throw new Error('Cannot call createRequestContext in the client');
  }
}

export function getRequestContext(): RequestContext {
  if (!__BROWSER__) {
    const asyncLocalStorage = getAsyncLocalStorage();
    const result = asyncLocalStorage.getStore()!.context;
    return result;
  } else {
    throw new Error('Cannot call getRequestContext in the client');
  }
}
